import React from "react";

export default class AmityErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.warn("[Amity] Chat component error caught by boundary:", error.message);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, color: "#888", textAlign: "center" }}>
          Chat temporarily unavailable. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}
